<template>
  <div id="my-remote-support reverse-mobile" class="row">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <h3>Remote Support</h3>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyRemoteSupport",
  components: {
    UserMenu
  }
};
</script>

<style scoped></style>
